import { required, maxLength, myWaitroseCardNumber, alreadyLinkedMsg } from 'utils/validation';

export const myWaitroseCardNumberValidator = [required, maxLength(16), myWaitroseCardNumber];
export const alreadyLinked = [required, alreadyLinkedMsg];
export const myWaitroseCardNumberRegisterValidator = {
  required: 'Enter a myWaitrose card number',
  maxLength: { value: 16, message: 'Must be no more than 16 characters' },
  validate: myWaitroseCardNumber,
};
